/**
 * Install once at app boot (index.js). Capture-phase listeners on window
 * fire before React / chat UI handlers and force navigation to the internal
 * feed for any scrollToArticle deep link.
 */
function extractArticleId(value) {
  if (!value || typeof value !== "string") return null;
  const match = value.match(/scrollToArticle=([^&#\s"']+)/i);
  if (!match || !match[1]) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch (_) {
    return match[1];
  }
}

function articleIdFromEventTarget(target) {
  let node = target;
  if (node && node.nodeType === 3) node = node.parentElement;
  if (!node || typeof node.closest !== "function") return null;

  const hit = node.closest(
    'a[href*="scrollToArticle"], [data-scroll-to-article]'
  );
  if (!hit) return null;

  return (
    hit.getAttribute("data-scroll-to-article") ||
    extractArticleId(hit.getAttribute("href") || "") ||
    extractArticleId(hit.href || "")
  );
}

function goToArticle(articleId) {
  const id = String(articleId);
  const target = `/articles?scrollToArticle=${encodeURIComponent(id)}&internal=1`;
  // eslint-disable-next-line no-console
  console.log("[ArticleLink] interceptor →", target);
  window.location.href = target;
}

function onInteract(event) {
  try {
    const articleId = articleIdFromEventTarget(event.target);
    if (!articleId) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
    goToArticle(articleId);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("[ArticleLink] interceptor error", err);
  }
}

export function installArticleLinkClickInterceptor() {
  if (typeof window === "undefined") return;
  if (window.__kjuupArticleLinkInterceptorInstalled) return;
  window.__kjuupArticleLinkInterceptorInstalled = true;
  // mousedown: some chat UI code prevents the subsequent click
  window.addEventListener("mousedown", onInteract, true);
  window.addEventListener("click", onInteract, true);
  window.addEventListener("auxclick", onInteract, true);
}
